// index.js
import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import './index.css';
import Login from './components/Login/Login';
import { BrowserRouter, Route, Switch} from 'react-router-dom';
import QuizMain from './components/quiz/QuizMain';
import VisitedUser from './components/general/VisitedUser'
import PageNotFound from './components/PageNotFound'
// import LastPage from '.components/LastPage'

class IndexRouter extends Component{
  render(){
  return (
  <BrowserRouter>
    <Switch>
      <Route exact path='/' component={Login} />
      <Route exact path='/math_quiz' component={QuizMain} />
      <Route exact path='/took_once' component={VisitedUser} />
      <Route component={PageNotFound}/>
    </Switch>
  </BrowserRouter>
  )}
}

export default IndexRouter;



// WEBPACK FOOTER //
// ./src/App.js